import React, { useEffect, useState } from 'react';
import ServiceBanner from '../../components/ServiceBanner';
import ServicePremimum from '../../components/ServicePremimum';
import ServicePlan from '../../components/ServicePlan';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";

const Service = () => {
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("service");

        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);



  return (
    <div>
      <Helmet>
        <title>
          {seoData.metaTitle || "Services | Nutrillion"}
        </title>

        <meta
          name="description"
          content={
            seoData.metaDescription ||
            "Explore personalized nutrition services and expert consultation."
          }
        />

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={
            seoData.canonicalUrl ||
            "https://nutrillion.one/service"
          }
        />
      </Helmet>
      <ServiceBanner />
      <ServicePremimum />
      <ServicePlan />
    </div>
  );
};

export default Service;